const STORAGE_KEY = "stichb_saved_drafts_v1";

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(records) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
}

function summarizeDraft(kind, draft) {
  if (!draft || typeof draft !== "object") {
    return "Draft";
  }

  if (kind === "booking") {
    return draft.garmentName || draft.design?.designName || draft.design?.style || "Stitching draft";
  }

  if (kind === "alteration") {
    return draft.garment?.name || draft.garmentName || "Alteration draft";
  }

  return draft.item?.name || draft.item?.serviceName || draft.workflow || "Saved draft";
}

function completedStepsOf(kind, draft) {
  if (!draft || typeof draft !== "object") return 0;

  if (kind === "booking") {
    let score = 0;
    if (draft.garmentName) score += 1;
    if (draft.design?.remoteUrl || draft.design?.localPath || draft.design?.designName) score += 1;
    if (draft.measurements?.method || draft.measurements?.selectedSize || Object.keys(draft.measurements || {}).length) score += 1;
    if (draft.fabric?.option) score += 1;
    if (draft.selectedAddOns?.length || draft.specialInstructions) score += 1;
    if (draft.delivery?.pickupMethod || draft.delivery?.deliveryMethod) score += 1;
    if (draft.customer?.name || draft.customer?.phone || draft.customer?.email) score += 1;
    return Math.min(score, 8);
  }

  if (kind === "alteration") {
    let score = 0;
    if (draft.garment?.name || draft.garmentName) score += 1;
    if ((draft.services || draft.selectedServices || []).length) score += 1;
    if (draft.details?.notes || draft.details?.condition) score += 1;
    if ((draft.details?.photoNames || []).length || (draft.details?.photoUrls || []).length) score += 1;
    if (draft.pickup?.pickupMethod || draft.pickup?.deliveryMethod) score += 1;
    if (draft.pickup?.date || draft.pickup?.timeSlot) score += 1;
    if (draft.pickup?.name || draft.pickup?.phone) score += 1;
    return Math.min(score, 8);
  }

  let score = 0;
  if (draft.workflow) score += 1;
  if (draft.item?.name || draft.item?.serviceName) score += 1;
  if (draft.details?.name || draft.details?.phone) score += 1;
  if (draft.details?.date || draft.details?.timeSlot) score += 1;
  if (draft.pricing?.total || draft.pricing?.unitPrice) score += 1;
  return Math.min(score, 8);
}

export function readSavedDrafts() {
  return readAll().sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
}

export function saveDraftRecord(kind, draft, extra = {}) {
  if (!draft || typeof draft !== "object") return null;

  const records = readAll();
  const title = summarizeDraft(kind, draft);
  const entry = {
    id: `${kind}_${Date.now()}_${Math.random().toString(16).slice(2)}`,
    kind,
    title,
    route: extra.route || "/services",
    path: extra.path || extra.route || "/services",
    updatedAt: new Date().toISOString(),
    completedSteps: completedStepsOf(kind, draft),
    draft,
  };

  const filtered = records.filter((item) => item.kind !== kind);
  filtered.push(entry);
  writeAll(filtered);
  return entry;
}

export function deleteSavedDraft(id) {
  const records = readAll().filter((item) => item.id !== id);
  writeAll(records);
}

export function hydrateDraftFromSavedRecord(kind, saved) {
  if (!saved || !saved.draft) return null;

  const draft = saved.draft;
  const keyMap = {
    booking: "stichb_booking_draft",
    alteration: "stichb_alteration_draft",
    workflow: "stichb_workflow_booking",
  };

  const key = keyMap[kind];
  if (!key) return draft;

  sessionStorage.setItem(key, JSON.stringify(draft));
  return draft;
}

export function refreshSavedDraft(kind, draft, extra = {}) {
  const records = readAll();
  const title = summarizeDraft(kind, draft);
  const current = records.find((item) => item.kind === kind);

  const next = {
    ...(current || {}),
    id: current?.id || `${kind}_${Date.now()}_${Math.random().toString(16).slice(2)}`,
    kind,
    title,
    route: extra.route || current?.route || "/services",
    path: extra.path || current?.path || extra.route || current?.route || "/services",
    updatedAt: new Date().toISOString(),
    completedSteps: completedStepsOf(kind, draft),
    draft,
  };

  writeAll([...records.filter((item) => item.kind !== kind), next]);
  return next;
}
